var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button } from "framework/controls/button";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { LoadingError } from "framework/controls/loading";
import { useEventsPlanningList } from "./store";
import { eventPlanningRoles, eventStateValues, getEventPlanningRoleName } from "../../entity";
import { useLocation } from "wouter";
import { cls_button_add_new_box, cls_col_date, cls_col_detailButton, cls_col_name, cls_col_roles, cls_col_state, cls_filter_item } from "./view.css";
import { cls_colorCyan70, cls_gap_form, cls_gap_rem, cls_p5b, cls_p5r, cls_p6r, cls_text_align_center } from "style/index.css";
import { Link } from "framework/link/link";
import { cls_table_body, cls_table_caption_row, cls_table_cell, cls_table_row } from "style/table.css";
import { getEventStateNaming, getEventStateStyleClassName } from "public_app/view/entity";
import { useUIContext } from "common/uicontext/store";
import { cls_box, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_space_between, cls_box_vertical, cls_align_items_center, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { getIsoStringDate } from "framework/helpers";
import { UrlPathOfPublicSection } from "common/paths";
import { Select, SelectItem } from "framework/controls/select";
import { DateField } from "framework/controls/date_field";
import { TextField } from "framework/controls/text_field";
import { getEntityField } from "framework/state/setfield";
import { cls_form_area_box } from "style/form.css";
import { Checkbox } from "framework/controls/checkbox";
import { cls_label } from "framework/controls/label.css";
import { EventCreationState } from "../editing/event/event";
import { useEventPlanning_Event } from "../editing/store";
var Filter = function () {
    var _a = useEventsPlanningList(), state = _a[0], actions = _a[1];
    var getter = function (field) {
        var value = getEntityField(state.filter, field);
        return value === null ? "null" : value === null || value === void 0 ? void 0 : value.toString();
    };
    var setter = function (field, value, validator, storeInvalidValue) {
        return actions.setFilterValue(field, value);
    };
    var getterDateOption = function (field) {
        var value = getEntityField(state.filter, "dateOption");
        return value === field;
    };
    var setterDate = function (field, value, validator, storeInvalidValue) {
        return actions.setFilterDateValue(field, value);
    };
    return React.createElement(HBox, null,
        React.createElement(HBox, { className: cls_form_area_box },
            React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
                React.createElement(HBox, { className: [cls_gap_form] },
                    React.createElement(VBox, { className: [cls_filter_item, cls_align_items_stretch] },
                        React.createElement(Select, { name: "state", label: "Stav", getter: getter, setter: setter },
                            React.createElement(SelectItem, { key: "null", value: "null", children: "- všechny -" }),
                            eventStateValues.map(function (x) { return React.createElement(SelectItem, { key: x.toString(), value: x.toString(), children: getEventStateNaming(x) }); }))),
                    React.createElement(VBox, { className: [cls_filter_item, cls_align_items_stretch] },
                        React.createElement(Select, { name: "role", label: "Pro roli", getter: getter, setter: setter },
                            React.createElement(SelectItem, { key: "null", value: "null", children: "- všechny -" }),
                            eventPlanningRoles.map(function (role) { return React.createElement(SelectItem, { key: role.toString(), value: role.toString(), children: getEventPlanningRoleName(role) }); }))),
                    React.createElement(VBox, { className: [cls_filter_item, cls_align_items_stretch] },
                        React.createElement(TextField, { name: "referenceNumber", label: "\u010C\u00EDslo jednac\u00ED", getter: getter, setter: setter }))),
                React.createElement(VBox, null,
                    React.createElement(HBox, { className: cls_label }, "Datum"),
                    React.createElement(HBox, { className: [cls_gap_form] },
                        React.createElement(Checkbox, { label: "V\u0161e", name: "all", getter: getterDateOption, setter: function () { return actions.setFilterValue("dateOption", "all"); } }),
                        React.createElement(Checkbox, { label: "Minul\u00E9", name: "past", getter: getterDateOption, setter: function () { return actions.setFilterValue("dateOption", "past"); } }),
                        React.createElement(Checkbox, { label: "Budouc\u00ED a dne\u0161n\u00ED", name: "future", getter: getterDateOption, setter: function () { return actions.setFilterValue("dateOption", "future"); } }),
                        React.createElement(Checkbox, { label: "Vybran\u00E9 obdob\u00ED", name: "range", getter: getterDateOption, setter: function () { return actions.setFilterValue("dateOption", "range"); } }))),
                state.filter.entity.dateOption === 'range' && React.createElement(HBox, { className: [cls_gap_form] },
                    React.createElement(VBox, { className: cls_filter_item },
                        React.createElement(DateField, { name: "dateFrom", label: "Datum od", getter: function () { return state.filter.entity.dateFrom; }, setter: setterDate })),
                    React.createElement(VBox, { className: cls_filter_item },
                        React.createElement(DateField, { name: "dateTo", label: "Datum do", getter: function () { return state.filter.entity.dateTo; }, setter: setterDate }))))));
};
var Item = function (ev) {
    var _a;
    var now = new Date();
    // const button_text = ev.date > now ? (uicontext_state.data.event_planning.isCompetitionCommissioner ? "Detail a schválení" : "Upravit") : "Detail";
    var button_text = ev.date > now ? "Upravit" : "Detail";
    return React.createElement(HBox, { className: [cls_p5r, cls_table_row] },
        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_flex_start, cls_justify_content_center, cls_col_date] }, getIsoStringDate(ev.date)),
        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_flex_start, cls_justify_content_center, cls_col_name] }, ev.name),
        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_col_state, getEventStateStyleClassName(ev.state)] }, getEventStateNaming(ev.state)),
        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_col_roles, cls_text_align_center, cls_p6r] }, (_a = ev.userPermissionRoles) === null || _a === void 0 ? void 0 : _a.map(function (role) { return getEventPlanningRoleName(role); }).join(", ")),
        React.createElement(VBox, { className: [cls_table_cell, cls_align_items_stretch, cls_justify_content_center, cls_col_detailButton] },
            React.createElement(Link, { url: "".concat(UrlPathOfPublicSection, "/planovani_akci/editace/").concat(ev.eventId), className: [cls_box, cls_box_vertical, cls_align_items_stretch] },
                React.createElement(Button, null, button_text))));
};
var Content = function () {
    var state = useEventsPlanningList()[0];
    var events = state.eventsList.events;
    var roleFilter = state.filter.entity.role;
    return React.createElement(VBox, null,
        React.createElement(HBox, { className: [cls_table_caption_row] },
            React.createElement(VBox, { className: [cls_table_cell, cls_align_items_flex_start, cls_justify_content_center, cls_col_date, cls_p5b] }, "Datum"),
            React.createElement(VBox, { className: [cls_table_cell, cls_align_items_flex_start, cls_justify_content_center, cls_col_name, cls_p5b] }, "Název"),
            React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_col_state, cls_p5b] }, "Stav"),
            React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_col_roles, cls_p5b] }, "Mé role"),
            React.createElement(VBox, { className: [cls_table_cell, cls_col_detailButton] })),
        React.createElement(VBox, { className: [cls_table_body] }, Object.keys(events).map(function (k) { return (React.createElement(VBox, { key: k },
            React.createElement(VBox, null, events[k].map(function (c) { return React.createElement(Item, __assign({ key: c.key_ }, c)); })))); })));
};
var EventCreationFailed = function () {
    return React.createElement(VBox, null, 'Vytvoření nové soutěže se nezdařilo!');
};
var View = function () {
    var _a = useUIContext(), loadEventPlanningUIContext = _a[1].loadEventPlanningUIContext;
    React.useEffect(function () {
        loadEventPlanningUIContext();
    }, []);
    var _b = useEventsPlanningList(), state = _b[0], loadEvents = _b[1].loadEvents;
    var loading = state.loading, loadFailure = state.loadFailure;
    var _c = useEventPlanning_Event(), _d = _c[0], creationState = _d.creationState, entity = _d.entity, actions = _c[1];
    var _e = useLocation(), setLocation = _e[1];
    React.useEffect(function () {
        loadEvents();
    }, []);
    React.useEffect(function () {
        switch (creationState) {
            case EventCreationState.Creating:
                actions.event_saveEvent(true);
                break;
            case EventCreationState.Created:
                actions.event_resetCreationState();
                setLocation("".concat(UrlPathOfPublicSection, "/planovani_akci/editace/").concat(entity.id));
                break;
        }
    }, [creationState]);
    var showContent = !loading && !loadFailure;
    var showCreationFailed = creationState === EventCreationState.Failed;
    var disableButton = creationState === EventCreationState.Creating || creationState === EventCreationState.Created;
    return React.createElement(VBox, { className: cls_gap_rem },
        React.createElement(HBox, { className: cls_justify_content_space_between },
            React.createElement("h3", { className: cls_colorCyan70 }, "Plánování akcí"),
            showContent && React.createElement(HBox, { className: cls_button_add_new_box },
                React.createElement(Button, { onClick: actions.event_createEvent, disabled: disableButton }, 'Vytvořit novou soutěž'))),
        showCreationFailed && React.createElement(EventCreationFailed, null),
        React.createElement(Filter, null),
        loadFailure && React.createElement(LoadingError, null),
        !loadFailure && React.createElement(Content, null));
};
export { View as EventPlanningList, };
